import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatCommonModule } from '@angular/material/core';

import { VendorManagementComponent } from '../../pages/vendor-management/vendor-management.component';

@Component({
  selector: 'app-edit-user',
  standalone: true,
  imports: [MatDialogModule,MatFormFieldModule, MatSelectModule, MatInputModule, FormsModule,MatCommonModule],
  templateUrl: './edit-user.component.html',
  styleUrl: './edit-user.component.css',
})
export class EditUserComponent {
        
  constructor(@Inject(MAT_DIALOG_DATA) public data: any ){};
  
  user=
  {
    strFname: '',
    strLname: '',
    strEmail:''
  }



  onSubmit(){};


   selectedOption: string | undefined ;

  // Optionally, handle any changes
  onSelectionChange(event: any) {
    console.log('Selected option:', event.value);
  }

  @Input() isVisible: boolean = false;
  @Output() closeModal = new EventEmitter<void>();

  close() {
    this.closeModal.emit();
  };



  

}
